import React, { useState, useEffect } from 'react';
import { number } from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';

import Fade from 'components/Fade';

const propTypes = {
  delay: number,
};

const defaultProps = {
  delay: 500,
};

const Spinner = ({ delay, ...iconProps }) => {
  const [isVisible, setVisible] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => setVisible(true), delay);
    return () => clearTimeout(timeout);
  }, [delay]);

  return (
    <Fade in={isVisible}>
      <div className="spinner">
        <FontAwesomeIcon icon={faCircleNotch} spin {...iconProps} />
      </div>
    </Fade>
  );
};

export default Spinner;

Spinner.propTypes = propTypes;
Spinner.defaultProps = defaultProps;
